import { useQuery } from 'react-query'

import { fetchCurrencies } from '@modules-deprecated/app/currencies/query-api'
import { CurrenciesState } from '@modules-deprecated/app/currencies/types'

import { QueryKeys } from '../enums/queryKeys'

interface UseCurrenciesProps {
  onSuccess?: (data: CurrenciesState) => void
}

export const useCurrencies = (props?: UseCurrenciesProps) => {
  const { onSuccess } = props || {}
  const { data } = useQuery([QueryKeys.Currencies], fetchCurrencies, { onSuccess })

  return { data }
}
